import { useParams } from 'react-router-dom';

import { DEV_MODE } from '../const';

const useBookingRootLink = () => {
	const { clientId } = useParams();
	return `/booking${DEV_MODE ? '' : `/${clientId}`}`;
};

export default useBookingRootLink;
